var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepImg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 39H56V44H0V39Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 53H40V55H16V53Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8921 26.251H32.252C32.0764 26.251 31.918 26.1477 31.8413 25.9825C31.7646 25.8199 31.7844 25.6237 31.8908 25.4792L40 14.6613V6.32664H34.3951C34.1427 6.32664 33.9373 6.1124 33.9373 5.84911V0H13V34H35.8923L35.8921 26.251ZM28.5551 24.4132H17.2512C16.9988 24.4132 16.7934 24.1989 16.7934 23.9356C16.7934 23.6724 16.9988 23.4581 17.2512 23.4581H28.5551C28.8075 23.4581 29.0104 23.6698 29.0104 23.9356C29.0104 24.2015 28.8075 24.4132 28.5551 24.4132ZM28.5551 17.1034H17.2512C16.9988 17.1034 16.7934 16.8892 16.7934 16.6259C16.7934 16.3626 16.9988 16.1484 17.2512 16.1484H28.5551C28.8075 16.1484 29.0104 16.3626 29.0104 16.6259C29.0104 16.8892 28.8075 17.1034 28.5551 17.1034ZM28.5551 9.7937H17.2512C16.9988 9.7937 16.7934 9.57945 16.7934 9.31616C16.7934 9.05288 16.9988 8.83863 17.2512 8.83863H28.5551C28.8075 8.83863 29.0104 9.05288 29.0104 9.31616C29.0104 9.57945 28.8075 9.7937 28.5551 9.7937Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6284 14.2384L50.0214 24.9305C50.1315 25.0734 50.152 25.2673 50.0726 25.428C49.9933 25.5913 49.8294 25.6934 49.6476 25.6934H45.8788V33.824C45.8788 34.0842 45.6689 34.2934 45.4051 34.2934H12.2717C12.0105 34.2934 11.798 34.0842 11.798 33.824V6H0V38H56V6H41.6287L41.6284 14.2384Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 45H36V52H20V45Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2667 34V25.505C44.2667 25.2331 44.4786 25.0119 44.7391 25.0119H48L40.5 15L33 25.0119H36.2609C36.5239 25.0119 36.7333 25.2331 36.7333 25.505V34H44.2667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepImg2);
export default __webpack_public_path__ + "static/media/stepImg2.ee2c2df05839aa45d5217762e1d44489.svg";
export { ForwardRef as ReactComponent };